<template>
  <div class="flex flex-col gap-y-[24px]">
    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!stepFormData.type?.title" />
        Тип КЗС
      </div>
      <VSelector
        :value="stepFormData.type"
        :items="typeVariants"
        absolute
        titleKey="title"
        :disabled="disabled"
        idKey="id"
        size="m"
        variant="gray"
        placeholder="Выберите тип КЗС"
        @input="emitTypeChange"
      />
    </div>
    <!-- End form item -->

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!stepFormData.algorithm?.title" />
        Алгоритм
      </div>
      <VSelector
        :value="stepFormData.algorithm"
        :items="availableAlgorithms"
        absolute
        titleKey="title"
        idKey="id"
        size="m"
        variant="gray"
        placeholder="Выберите тип"
        @input="emitAlgorithmChange"
        :disabled="isAlgoSelectorDisabled"
      />
    </div>
    <!-- End form item -->
  </div>

</template>

<script>
import { VSelector } from '@gostelemed.front/rt-doctis.designsystem';
import RequiredIndicator from '@/components/base/RequiredIndicator.vue';

export default {
  name: 'SelectAlgoPart',
  components: {
    VSelector,
    RequiredIndicator,
  },
  props: {
    stepFormData: {
      type: Object,
      required: true,
    },
    typeVariants: {
      type: Array,
      required: true,
    },
    availableAlgorithms: {
      type: Array,
      required: true,
    },
    isAlgoSelectorDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitTypeChange(value) {
      this.$emit('on-type-change', value);
    },
    emitAlgorithmChange(value) {
      this.$emit('on-algorithm-change', value);
    },
  },
};
</script>
